import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVEdTechStoreKeyMap } from './mmkvEdTechStoreKeyMap';

export const mmkvEdTechProductPersistence = new MMKV({
  id: MMKVEdTechStoreKeyMap.productStore,
});

export const zustanEdTechProductStorage: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvEdTechProductPersistence.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvEdTechProductPersistence.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvEdTechProductPersistence.delete(name);
  },
};
